import { useEffect } from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Home from "./pages/home/HomePage";
import AboutUs from "./pages/aboutUs/AboutUsPage";
import AcademicPage from "./pages/academics/AcademicPage";
import BasicEducation from "./pages/academics/BasicEducation";
import TertiaryEducation from "./pages/academics/TertiaryEducation";
import AdmissionPage from "./pages/admission/AdmissionPage";

import AlumniPage from "./pages/alumni/AlumniPage";
import NewsPage from "./pages/home/NewsPage";
import ContactPage from "./pages/contact/ContactPage";
import FacilitiesPage from "./pages/home/FacilitiesPage";
function App() {
  return (
    <Router>
      {" "}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/news/:title" element={<NewsPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/academics" element={<AcademicPage />} />{" "}
        <Route path="/academics/basic-education" element={<BasicEducation />} />
        <Route
          path="/academics/tertiary-education"
          element={<TertiaryEducation />}
        />{" "}
        <Route path="/admission" element={<AdmissionPage />} />{" "}
        <Route path="/alumni" element={<AlumniPage />} />{" "}
        <Route path="/contactUs" element={<ContactPage />} />
        <Route path="/facilities" element={<FacilitiesPage />} />
      </Routes>
    </Router>
  );
}

export default App;

const ScrollToTop = () => {
  const { pathname } = useLocation(); // Get the current route path

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the route changes
  }, [pathname]); // Trigger the effect when the route path changes

  return null; // No visual render
};
